import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckoutComponent } from './checkout/checkout.component';
import { PagesRoutingModule } from './pages-routing.module';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorPageComponent } from './error-page/error-page.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { TranslateModule } from '@ngx-translate/core';
import { SignupComponent } from 'src/app/components/pages/signup/signup.component';
import { ApplicationComponent } from './application/application.component';
import { OrderHistoryComponent } from './order-history/order-history.component';
import { ManageAutoshipComponent } from './manage-autoship/manage-autoship.component';
import { OrderInvoiceComponent } from './order-invoice/order-invoice.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
// import { HomeComponent } from './home/home.component';
import { MainCarouselComponent } from '../shop/main-carousel/main-carousel.component';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { PackCarouselComponent } from '../shared/pack-carousel/pack-carousel.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDividerModule } from '@angular/material/divider';
import { MatRadioModule } from '@angular/material/radio';
import { MatListModule } from '@angular/material/list';
import { MatSliderModule } from '@angular/material/slider';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatBadgeModule } from '@angular/material/badge';
import { CustomerTypeCarouselComponent } from '../shared/customer-type-carousel/customer-type-carousel.component';
import { CompleteComponent } from './complete/complete.component';
import { MatSortModule } from '@angular/material/sort';
import { NgxPrintModule } from 'ngx-print';
import { ContactComponent } from './contacts/contacts.component';
import { FlickityComponent } from './flickity/flickity.component';
import { FlickityModule } from 'ngx-flickity';
import 'flickity-as-nav-for';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { LoyaltyRewardsComponent } from './loyalty-rewards/loyalty-rewards.component';
import { NgbCarousel, NgbCarouselConfig, NgbCarouselModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ngbCarouselTransitionIn, ngbCarouselTransitionOut, NgbSlideEventDirection } from '@ng-bootstrap/ng-bootstrap/carousel/carousel-transition';
import { NGB_CAROUSEL_DIRECTIVES } from '@ng-bootstrap/ng-bootstrap/carousel/carousel';
import { IntroCarouselComponent } from '../shared/intro-carousel/intro-carousel.component';
import { MembershipComponent } from './membership/member.component';
import { ShopproductsComponent } from './shopproducts/shopproducts.component';
import { MatTreeModule } from '@angular/material/tree';
import { IntialorderCarouselComponent } from '../shared/intialorder-carousel/intialorder-carousel.component';
import { PackCarouselAutoshipComponent } from '../shared/pack-carousel-autoship/pack-carousel-autoship.component';
import { ProductSearchPipeCategory } from '../shared/pipes/product-search-category.pipe';
// import { HomeNewComponent } from './home/home.component';
import { ProductDetailsCarouselComponent } from '../shared/product-details-carousel/product-details-carousel.component';
import { TopProductsComponent } from '../shared/top-products/top-products.component';

import { TheGroveComponent } from './the-grove/the-grove.component';

import { OurStoryComponent } from './our-story/our-story.component';
import { LifeInBalanceComponent } from '../shared/life-in-balance/life-in-balance.component';
import { ShopnowComponent } from './shopnow/shopnow.component';
import { FunstoreComponent } from './funstore/funstore.component';
import { FunvibersComponent } from './funvibers/funvibers.component';
import { ActivatorJoinComponent } from './activator-join/activator-join.component';
import { FunstudiosComponent } from './funstudios/funstudios.component';
import { WeightlossComponent } from './weightloss/weightloss.component';
import { AcneincomeComponent } from './acneincome/acneincome.component';
import { TheFunstudioComponent } from './the-funstudio/the-funstudio.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatNativeDateModule } from '@angular/material/core';
import { RewardPlanComponent } from './reward-plan/reward-plan.component';
import { homeComponent } from './home/home.component';
import { BrainMoodAndEnergyComponent } from './brain-mood-and-energy/brain-mood-and-energy.component';

import { AboutUsComponent } from './aboutus/aboutus.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { MarketplaceComponent } from './marketplace/marketplace.component';
import { RewardsComponent } from './rewards/rewards.component';
import { BouncebackRewardsComponent } from './bounceback-rewards/bounceback-rewards.component';
import { OurFoundersComponent } from './our-founders/our-founders.component';


@NgModule({
  imports: [
    MatTreeModule,
    CommonModule,
    NgbCarouselModule,
    NgbModule,
    FormsModule,
    SwiperModule,
    ReactiveFormsModule,
    PagesRoutingModule,
    SharedModule,
    NgxSkeletonLoaderModule,
    TranslateModule,
    MatButtonModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatListModule,
    MatChipsModule,
    MatExpansionModule,
    MatMenuModule,
    MatTableModule,
    MatSliderModule,
    MatRadioModule,
    MatDialogModule,
    MatChipsModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatPaginatorModule,
    MatSortModule,
    MatCheckboxModule,
    MatSidenavModule,
    MatSelectModule,
    MatTabsModule,
    MatDividerModule,
    MatCardModule,
    MatDatepickerModule,
    MatBadgeModule,
    NgxPrintModule,
    FlickityModule,
    NgxImageZoomModule,
    MatStepperModule,
    MatNativeDateModule
  ],
  declarations: [
    ProductSearchPipeCategory,
    MainCarouselComponent,
    homeComponent,
    CheckoutComponent,
    ErrorPageComponent,
    SignupComponent,
    ApplicationComponent,
    OrderHistoryComponent,
    ManageAutoshipComponent,
    OrderInvoiceComponent,
    ForgotPasswordComponent,
    PackCarouselComponent,
    IntialorderCarouselComponent,
    PackCarouselAutoshipComponent,
    CustomerTypeCarouselComponent,
    CompleteComponent,
    ContactComponent,
    FlickityComponent,
    LoyaltyRewardsComponent,
    IntroCarouselComponent,
    MembershipComponent,
    ShopproductsComponent,
    ShopnowComponent,
    FunstoreComponent,
    FunvibersComponent,
    ActivatorJoinComponent,
    FunstudiosComponent,
    WeightlossComponent,
    AcneincomeComponent,
    TheFunstudioComponent,
    ProductDetailsComponent,
    // HomeNewComponent,

    TheGroveComponent,

    RewardPlanComponent,
    OurStoryComponent,
    ProductDetailsCarouselComponent,
    TopProductsComponent,
    LifeInBalanceComponent,
    BrainMoodAndEnergyComponent,

    AboutUsComponent,
    TermsOfServiceComponent,
    PrivacyPolicyComponent,
    MarketplaceComponent,
    RewardsComponent,
    BouncebackRewardsComponent,
    OurFoundersComponent,

  ],
  exports: [
    MatButtonModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatListModule,
    MatChipsModule,
    MatExpansionModule,
    MatMenuModule,
    MatTableModule,
    MatSortModule,
    MatSliderModule,
    MatRadioModule,
    MatDialogModule,
    MatChipsModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatPaginatorModule,
    NgxPrintModule,
    MatCheckboxModule,
    MatSidenavModule,
    MatSelectModule,
    MatTabsModule,
    MatDividerModule,
    MatCardModule,
    MatDatepickerModule,
    MatBadgeModule,
    MatStepperModule
  ],
})
export class PagesModule { }
